<template>
  <el-time-picker
    :model-value="modelValue"
    format="HH:mm"
    value-format="HH:mm"
    :placeholder="placeholder"
    style="width: 100%;"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  modelValue?: string
  placeholder?: string
}>(), {
  modelValue: '',
  placeholder: '请选择时间',
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>
